var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v("Pull List")]),_vm._l((_vm.items),function(item,index){return _c('div',{key:index},[_c('b-row',[_c('b-col',[_c('print-item',{attrs:{"item":item}})],1)],1)],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }